import { render, staticRenderFns } from "./index.vue?vue&type=template&id=168f3738&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=168f3738&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=168f3738&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f3738",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168f3738')) {
      api.createRecord('168f3738', component.options)
    } else {
      api.reload('168f3738', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=168f3738&scoped=true", function () {
      api.rerender('168f3738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/occurrences/ratings/index.vue"
export default component.exports